import { render, staticRenderFns } from "./businessCustomerAudit.vue?vue&type=template&id=bdbf0da4&scoped=true"
import script from "./businessCustomerAudit.vue?vue&type=script&lang=js"
export * from "./businessCustomerAudit.vue?vue&type=script&lang=js"
import style0 from "./businessCustomerAudit.vue?vue&type=style&index=0&id=bdbf0da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbf0da4",
  null
  
)

export default component.exports